<template>
  <div>
    <v-row v-if="user.business_token">
      <v-col cols="12" md="12">
        <m-form
            :title="title"
            :showList="true"
            :cols="cols"
            @click:row="setItem"
            :list_filters.sync="filters"
            :api-url="apiUrl"
            :show-submit-and-clear-btn="false"
            :show-creation-data="false"
            :show-list-btn="false"
            :canDelete="item.id >= 1"
            :items="items"
            :canSubmit="canSubmit"
            :isEditing.sync="isEditing"
            :show-navigation-btns="false"
            @submit="submit"
            :show-actions="false"
            @delete="deleteItem"
            @clearForm="clearForm()"
            ref="CurrencyForm"
        >
          <template>
            <v-row class="mb-5 mt-5" v-if="!item.id">
              <v-col cols="12" class="text-center">
                <span class="font-weight-bold white--text" style="font-size: x-large" >
                  یک سفارش را از لیست انتخاب کنید
                </span>
              </v-col>
            </v-row>
            <v-row v-if="item.id">
              <v-col cols="12">
                <v-card class="rounded-lg white" >
                  <v-card-title class="secondary white--text">
                    <span style="font-size: x-small"  class="mr-1 ml-1">
                            نام مشتری : {{ item.customer_name }}
                    -
                    </span>
                    <span style="font-size: xx-small" class="mr-1 ml-1">
                              شماره تماس :
                             {{ item.phone }}
                    -
                    </span>
                    <span style="font-size: xx-small" class="mr-1 ml-1">
                              ادرس  :
                             {{ item.address }}
                    -
                    </span>

                    <span style="font-size: xx-small" class="mr-1 ml-1">
                              کد پستی  :
                             {{ item.postal_code }}
                    -
                    </span>

                    <span v-if="item.business" style="font-size: xx-small" class="mr-1 ml-1">
                              در کسب و کار  :
                             {{ item.business.name }}
                    -
                    </span>
                    <span v-if="item.business" style="font-size: xx-small" class="mr-1 ml-1">
                              وضعیت  :
                             {{ item.status_display }}
                    </span>

                  </v-card-title>
                  <v-card-text>
                    <v-simple-table>
                      <thead>
                      <tr class="lightSecondary">
                        <th class="text-center white--text lightSecondary" style="font-size: x-small">
                          نام کالا
                        </th>
                        <th class="text-center white--text lightSecondary" style="font-size: x-small">
                          بارکد کالا
                        </th>
                        <th class="text-center white--text lightSecondary" style="font-size: x-small">
                          تعداد
                        </th>
                        <th class="text-center white--text lightSecondary" style="font-size: x-small">
                          قیمت فروش رفته
                        </th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(row, index) in item.items">
                        <td style="font-size: x-small" class="text-center">
                          {{row.product.name}}
                        </td>
                        <td style="font-size: x-small" class="text-center">
                          {{row.product.barcode}}
                        </td>
                        <td style="font-size: x-small" class="text-center">
                          {{row.quantity | toMoney}}
                        </td>
                        <td style="font-size: x-small" class="text-center">
                          {{row.price | toMoney}}
                        </td>

                      </tr>
                      </tbody>
                    </v-simple-table>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </template>
        </m-form>

      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <v-card class="white rounded-lg" >
          <v-card-title class="error white--text">کسب و کار فعال نیست
          </v-card-title>
        </v-card>

      </v-col>
    </v-row>
  </div>

</template>

<script>

import {MFormMixin} from "@/components/m-form";
import FormsMixin from "@/mixin/forms";
import {PathLevels, VisitorLevels} from "@/variables";
import formsMixin from "@/mixin/forms";
import money from "@/components/mcomponents/cleave/Money";
import cart from "@/components/scomponents/Cart";
import UserSelect from "@/components/selects/UserSelect";


export default {
  name: "BusinessPaidOrders",
  mixins: [MFormMixin, formsMixin, FormsMixin],
  components: {
    UserSelect,
    cart
  },

  props: {
    id: {},
  },
  data() {
    return {
      printUrl: 'affiliate/factor/all',
      baseUrl: "affiliate/factorCreate",
      permissionBasename: "affiliate_factor",
      appendSlash: false,
      hasList: false,
      no_edit_dialog: false,
      hasIdProp: true,
      show_setting: false,
      hasLock: false,
      error_dialog: false,
      error_message: null,
      isDefinable: false,
      myClass: '',
      ss: null,
      PathLevels,
      VisitorLevels,
      filters: {
        is_paid: true
      },
      paymentDialog: false,
      payment: '',
      performClearForm: true,
      items: [],
      first: false,
      cols: [
        {
          text: "نام کسب و کار",
          value: "business.name",
        },
        {
          text: "نام مشتری",
          value: "customer_name",
        },
        {
          text: "تلفن",
          value: "phone",
        },
        {
          text: "آدرس",
          value: "address",
        },
        {
          text: "مبلغ فاکتور",
          value: "factor_price_sum",
          type: 'numeric',
          filterable: false
        },

        {
          text: "وضعیت",
          value: "status_display",
        },
      ],

    };
  },
  computed: {
    apiUrl() {
      return `affiliate/factor/all?businessToken=${this.user.business_token}`
    },
    title() {
      return 'تراکنش ها'
    },
    headers() {
      return [];
    },
  },
  updated() {
  },
  created() {
  },
  methods: {

  },
}
</script>

<style scoped lang="scss"></style>

